export default {
  VERSIONS_MODAL: {
    TITLE: `Versions`,
    SUMMARY: ``
  },
  FEATURES: `Fonctionnalités`,
  IMPROVEMENTS: `Améliorations`,
  FIXES: `Réparations`
}
